import KunLoading113 from './src/index'

KunLoading113.install = function (Vue) {
	Vue.component(KunLoading113.name, KunLoading113);
}

export default KunLoading113;
